import React from 'react';
import PropTypes from 'prop-types';
import './CoverflowBase.css'

import IconClose from '../svg/IconClose';

function ContainerTopActions({ isFullScreen = false, onFullScreen, toggle }) {
  return (
    <div className={`flexRow space-between align cf-top-actions`}>
      <IconClose className={`cf-close`} onClick={toggle} size={24} />
    </div>
  )
}

ContainerTopActions.propTypes = {
  onFullScreen: PropTypes.func,
  isFullScreen: PropTypes.bool,
}

export default ContainerTopActions;
